import { ChangeDetectorRef, Component, Injector, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { BaseComponent } from '@app/shared/base/base-component/base-component.component';
import {
  FilterType,
  FrontEndColumn,
} from '@app/shared/interfaces/front-end-column';
import { ProductSelectorComponent } from '@product/product-selector/product-selector.component';
import { FilterOperator } from '@product/shared/models/Enums.enum';
import { GroupedProduct } from '@product/shared/models/GroupedProduct';
import { FilterObject, ListPayload } from '@product/shared/models/ListPayload';
import { Product } from '@product/shared/models/product';
import { productColumns } from '@product/shared/product-base-logic';
import { ProductService } from '@product/shared/services/product.service';
import { NzDrawerRef } from 'ng-zorro-antd/drawer';
import { NzModalService } from 'ng-zorro-antd/modal';
import { NzTableComponent } from 'ng-zorro-antd/table';
import { catchError, of, switchMap, tap } from 'rxjs';
import { HardCopy } from 'src/global-variables';

@Component({
  selector: 'app-grouped-product',
  templateUrl: './grouped-product.component.html',
  styleUrls: ['./grouped-product.component.less'],
})
export class GroupedProductComponent extends BaseComponent implements OnInit {

  selectedProductsOld: Set<Product> = new Set();
  @ViewChild(ProductSelectorComponent) productSelector: ProductSelectorComponent;
  @Input() productId?:number=0;
  savedFilters: { [key: string]: FilterObject } | null = {};
  pageIndex = 1;
  pageSize = 10;
  
  tableParams = {
    index: 1,
    size: 10,
  };
  onPageChange(pageIndex: number) {
    this.tableParams.index = pageIndex;

  }

  selectedProducts: any[] = [];
  productData: any[] = [];

  //Search var
  searchTerm: string = ''; 
  displayedProducts: any[] = [];


  _formGroup: FormGroup;
  translationMode: boolean;
  @Input() set formGroup(value: FormGroup) {
    if (value != null)
      value.addControl('groupedProductBaseProducts', this.formArray);
    this._formGroup = value;
  }
  get formGroup() {
    return this._formGroup;
  }
  formArray: FormArray;
  checked = false;
  loading = false;
  indeterminate = false;
  setOfCheckedId = new Set<number>();
  selectedId = 0;
  products: any[] = [];
  baseProducts: any[] = [];
  setOfHiddenRows = new Set<number>();
  constructor(injector: Injector, private productService: ProductService,
    private cdr: ChangeDetectorRef,
  ) {
    super(injector);
    this.formArray = this.fb.array([]);
  }


  tmpSelectedProducts: Set<Product> = new Set();
  tempProductsModal: NzDrawerRef<any, any>;
  

  drawerPayload: ListPayload = {
    SearchValue: '',
    Filters: {},
    IsAscend: false,
    SortBy: 'Id',
    PageIndex: 0,
    PageSize: 10,
    Attributes: []
  };


  drawerProducts: Product[] = [];
  drawerTotalCount = 0;
  isDrawerLoading = false;
  listColumns = productColumns;
  @ViewChild('selectingProductsTmp')
  selectingProductsTemplate: TemplateRef<any>;
  @ViewChild('drawerFooterTmp') drawerFooterTmp: TemplateRef<any>;

  @ViewChild('productsTable', { static: false }) productsTable: NzTableComponent<any>;
  
  ngOnInit() {
    this.resetFilterTypes();
    this.getSavedFilters();
    this.getProducts();
    
    const params$ = this.route.params
      .pipe(
        tap((params) => {
          const lang = params['language'];
          if (lang != null && lang != '') {
            this.translationMode = true;
          }
          if (params['id'] != null) {
            this.selectedId = +params['id'];
          } else {
            this.selectedId = 0;
          }
        }),
        switchMap(() => this.getProducts())
      )
      .subscribe();
    this.subscriptions.push(params$);
   
    this.getGroupedProduct();
   
    
  }
  getGroupedProduct() {
    this.productService.getGroupProducts(this.selectedId).subscribe(
      {
        next: (data) => {
          this.productData = data;
          this.displayedProducts = [...this.productData];
          this.getselectedProductsOld();
          this.addOldProductsToFormArray();

        },
        error: (error) => {
          console.error('error get data : ', error);

        }
      })
  }
  getselectedProductsOld(){
    this.selectedProductsOld = new Set(this.productData.map(product => ({
      id: product.childProductId,
      name: product.name,
      sku: product.sku,
      position: product.position,
      defaultQuantity: product.defaultQuantity,
    } as Product)));
  }
  getProducts() {
    return this.productService
      .getProductsList({
        IsAscend: true,
        PageIndex: 0,
        PageSize: 0,
        SortBy: 'Id',
        Filters: {
          type: {
            Operator: FilterOperator.isEqual,
            Type: FilterType.String,
            Value: 'simple',
            AdditionalInfo: '',
          },
        },
      })
      .pipe(
        tap((response) => {
          this.products = response.records;
          // this.products
          //   .filter((x) => x.id != this.selectedId)
          //   .forEach((product) => {
          //     // this.formArray.push(
          //     //   new FormGroup({
          //     //     position: new FormControl({ value: null, disabled: true }),
          //     //     defaultQuantity: new FormControl({
          //     //       value: null,
          //     //       disabled: true,
          //     //     }),
          //     //     childProductId: new FormControl(product.id),
          //     //   })
          //     // );
          //   });
        }),
        switchMap(() => {
          if (this.selectedId != 0) {
            return this.productService.getGroupProducts(this.selectedId);
          } else {
            return of(false);
          }
        }),
        tap((response: any[] | boolean) => {
          if (typeof response !== 'boolean') {
            const ids = response.map((x) => x.childProductId);

            ids.forEach((id) => {
              this.setOfCheckedId.add(id);
              this.updateCheckedSet(id, true);
              const index = this.products.findIndex((x) => x.id == id);
              const control = this.formArray.get(index.toString()) as FormGroup;
              const value = response.find(
                (x) =>
                  x.baseProductId == this.selectedId && x.childProductId == id
              );
              if (
                [
                  //value.position,
                  // value.defaultQuantity,
                  // value.childProductId,
                ].every((x) => x != null)
              ) {
                control?.setValue({
                  position: value.position,
                  defaultQuantity: value.defaultQuantity,
                  childProductId: value.childProductId,
                });
              }
            });
            this.formArray.controls = [
              ...this.formArray.controls.sort((a, b) => {
                const first = (a as FormGroup).get('childProductId')?.value;
                const second = (b as FormGroup).get('childProductId')?.value;
                return this.sortBySelectedFirst(first, second);
              }),
            ];
            this.products = [
              ...this.products.sort((a, b) => {
                return this.sortBySelectedFirst(a.id, b.id);
              }),
            ];
            this.baseProducts = HardCopy(this.products);
          }
        })
      );
  }
  refreshCheckedStatus(): void {
    this.checked = this.products.every(({ id }) => this.setOfCheckedId.has(id));
    this.indeterminate =
      this.products.some(({ id }) => this.setOfCheckedId.has(id)) &&
      !this.checked;
    this.formGroup.markAsDirty();
    this.formGroup.markAsTouched();
  }
  updateCheckedSet(id: number, checked: boolean): void {
    const index = this.products.findIndex((x) => x.id == id);
    const control = this.formArray.get(index.toString()) as FormGroup;
    if (control == null) return;
    if (checked) {
      this.setOfCheckedId.add(id);
      if (!this.translationMode) control.enable();
    } else {
      this.setOfCheckedId.delete(id);
      control.setValue({
        position: null,
        defaultQuantity: null,
        childProductId: id,
      });
      control.disable();
    }
    this.refreshCheckedStatus();
  }
  onItemChecked(id: number, checked: boolean): void {
    this.updateCheckedSet(id, checked);
  }
  onAllChecked(checked: boolean): void {
    this.products.forEach(({ id }) => this.updateCheckedSet(id, checked));
    this.refreshCheckedStatus();
  }
  get TableLines() {
    return this.formArray.controls as FormGroup[];
  }
  sortBySelectedFirst(a: any, b: any): number {
    const aIsSelected = this.setOfCheckedId.has(a);
    const bIsSelected = this.setOfCheckedId.has(b);
    // If both products are selected or unselected, maintain their original order
    if (aIsSelected === bIsSelected) {
      return 0;
    }
    // If a is selected and b is not, move a to a lower index
    if (aIsSelected) {
      return -1;
    }
    // If b is selected and a is not, move b to a lower index
    return 1;
  }
  // onSearchChange(event: any, element: any) {
  //   console.log('element : ',element.value);
    
  //   const searchStatement = element.value;
  //   if (event instanceof KeyboardEvent && event.key === 'Enter') {
  //     const products = this.productData.filter(
  //       (x) =>
  //         x.sku.includes(searchStatement) || x.name.includes(searchStatement)
  //     );
  //     this.setOfHiddenRows = new Set(
  //       this.products
  //         .map((x) => x.id)
  //         .filter((prodId) => !products.map((x) => x.id).includes(prodId))
  //     );
  //   } else if (event instanceof FocusEvent) {
  //     const products = this.productData .filter(
  //       (x) =>
  //         x.sku.includes(searchStatement) || x.name.includes(searchStatement)
  //     );
  //     this.setOfHiddenRows = new Set(
  //       this.products
  //         .map((x) => x.id)
  //         .filter((prodId) => !products.map((x) => x.id).includes(prodId))
  //     );
  //   } else {
  //     return;
  //   }
  // }
 

  searchChange() {
    const searchStatement = this.searchTerm.toLowerCase();
    this.displayedProducts = this.productData.filter(
      (product) =>
        product.sku.toLowerCase().includes(searchStatement) ||
        product.name.toLowerCase().includes(searchStatement)
    );
  }
  
  


  openProductsDrawer() {
    this.tempProductsModal = this.drawerService.create({
      nzContent: this.selectingProductsTemplate,
      nzTitle: 'Choose products to assign',
      nzWrapClassName: 'drawer-size-3x',
      nzFooter: this.drawerFooterTmp,
    });
    this.subscriptions.push(
      this.tempProductsModal.afterOpen
        .pipe(switchMap(() => this.getDrawerProducts()))
        .subscribe()
    );
  }

  getDrawerProducts() {
    this.drawerPayload.Filters = { ...this.savedFilters };
    this.drawerPayload.Filters['Id'] = {
      Operator: FilterOperator.isNotEqual,
      Type: FilterType.Number,
      Value: this.selectedId.toString(),
      AdditionalInfo: '',
    };
    this.isDrawerLoading = true;
    return this.productService.getProductsList(this.drawerPayload).pipe(
      tap((response) => {
        this.drawerProducts = response.records;
        this.drawerTotalCount = response.recordsCount;
        this.isDrawerLoading = false;
      }),
      catchError((error) => {
        console.error('Error details:', error.error.errors);
        this.isDrawerLoading = false;
        return of([]);
      })
    );
  }
  refreshDrawerProducts() {
    this.getDrawerProducts();
  }

  onDrawerFiltersChange(filter: any) {
    if (filter == null) return;
    // deleting the filter if the value was null or empty
    const additionalInfo = JSON.parse(filter.filter?.AdditionalInfo ?? '{}');
    if (
      (['', null, undefined, 'null'].includes(filter.filter?.Value?.trim()) &&
        additionalInfo.needValue == null) ||
      (additionalInfo.needValue != null && additionalInfo.needValue === true)
    ) {
      delete this.drawerPayload.Filters[filter.code];
    }
    const keys = Object.keys(this.drawerPayload.Filters);

    if (keys.includes(filter.code)) {
      this.drawerPayload.Filters[filter.code] = filter.filter;
    } else if (
      !['', null, undefined, 'null'].includes(filter.filter?.Value) ||
      additionalInfo.needValue === false
    ) {
      this.drawerPayload.Filters = {
        ...this.drawerPayload.Filters,
        [filter.code]: filter.filter,
      };
    }
    this.subscriptions.push(this.getDrawerProducts().subscribe());
  }
  onSelectedProductsChange(data: Set<Product>) {
    this.tmpSelectedProducts = data;
  }

  submitProducts() {
    Array.from(this.tmpSelectedProducts)
      .map((x) => x.id)
      .forEach((prodId) => {
        /*this.formArray.push(
          new FormGroup({
            productId: new FormControl(this.productId),
            relationId: new FormControl(this.tempRelationId),
            objectId: new FormControl(prodId),
            objectType: new FormControl(12),
          })
        );*/
      });
   
    this.tmpSelectedProducts.clear();
    this.tempProductsModal.close();
  }
  cancelProductsSelction() {
    this.tmpSelectedProducts.clear();
    this.tempProductsModal.close();
  }


  openProductSelector() {
    this.productSelector.openDrawer();
  }

  addOldProductsToFormArray() {
    this.productData.forEach((product) => {
      const formGroup = new FormGroup({
        baseProductId: new FormControl(this.selectedId),
        childProductId: new FormControl(product.childProductId),
        position: new FormControl(product.position ?? 1),
        defaultQuantity: new FormControl(product.defaultQuantity ?? 1),

      });

      this.formArray.push(formGroup);
  

    });
  }
  handleProductSelection(selectedProducts: Product[]) {
    selectedProducts.forEach((product) => {
      const alreadyExistsInFormArray = this.formArray.controls.some(
        (control) => control.value.childProductId === product.id
      );
     
      const alreadyExistsInProductData = this.productData.some(
        (item) => item.childProductId === product.id
      );
     
      if (!alreadyExistsInFormArray && !alreadyExistsInProductData) {
       
        const formGroup = new FormGroup({
          baseProductId: new FormControl(this.selectedId),
          childProductId: new FormControl(product.id),
          position: new FormControl(product.position ?? 1),
          defaultQuantity: new FormControl(product.defaultQuantity ?? 1),
        });
        this.formArray.push(formGroup);
       
        this.productData.push({
          name: product.name,
          sku: product.sku,
          position: product.position ?? 1,
          defaultQuantity: product.defaultQuantity ?? 1,
          childProductId: product.id ?? 1,
        });

        this.displayedProducts = [...this.productData];
      
        
      }
      // else {
        
      //   this.message.error(`The product "${product.name}" has already been added.`);
      // }
    });
  
    
    this.cdr.detectChanges();
  }

  deleteProduct(childProductId: number): void {
    const index = this.displayedProducts.findIndex((product) => product.childProductId === childProductId);

    if (index > -1) {
      this.displayedProducts.splice(index, 1);
      //this.displayedProducts = [...this.productData];
      this.productsTable.data=this.displayedProducts;
      this.message.success('Product deleted successfully.');
      this.formArray.removeAt(index);
    }
    else {
      this.message.error('Product not found, deletion failed.');
    }
  }

  //method filter
  getSavedFilters() {
    const savedFiltersFromStorage = localStorage.getItem('saved-filter-values');
    if (savedFiltersFromStorage) {
      this.savedFilters = JSON.parse(savedFiltersFromStorage);
      if (this.savedFilters) {
        Object.keys(this.savedFilters).forEach((key) => {
          const filter = this.savedFilters![key];
          filter.Value = '';
          filter.Values = [];
        });
      }
      localStorage.setItem('saved-filter-values', JSON.stringify(this.savedFilters));
    }
  }
  
  handleFilterChanges(updatedFilters: { [key: string]: FilterObject }) {
    this.savedFilters = updatedFilters;
    this.drawerPayload.Filters = { ...this.savedFilters };
    this.getProducts().subscribe();
  }

  //update value filed position and defaultQuantity
  updateFormArrayValue(index: number, field: string, value: any) {

    const formGroup = this.formArray.at(index) as FormGroup;
  
    if (formGroup) {
      formGroup.get(field)?.setValue(value);
    }
  }
  
  resetFilterTypes(): void {
   
    Object.keys(localStorage).forEach((key) => {
        if (key.startsWith("filterType_")) {
            localStorage.removeItem(key); 
        }
    });
}

}


